import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';

@Component({
    selector: 'app-amount-input',
    template: `
        <app-number-input [parentFormGroup]="parentFormGroup" [parentFormControlName]="parentFormControlName"
                          [required]="required"
                          invalidNumberLabel="Veuillez renseigner un montant valide"
                          [decimalDigits]="decimalDigits"
                          [unit]="unit"
                          [minValue]="minValue"
                          [maxValue]="maxValue"
                          (valueChangedEvent)="valueChangedEvent.emit($event)"
        ></app-number-input>

    `
})
export class AmountInputComponent  {
    @Input() parentFormGroup: UntypedFormGroup;
    @Input() parentFormControlName = 'amount';
    @Input() required = false;
    @Input() unit = '€';
    @Input() decimalDigits = 2;
    @Input() minValue = 0;
    @Input() maxValue: number;

    @Output() valueChangedEvent: EventEmitter<number> = new EventEmitter<number>();
}

